import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PopularDestinationService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  // GET roles
  getAllPopularDestination(langCode: string): Observable<any> {
    if(langCode === ""){
      return this.http.get(`${this.apiUrl}popular-destination`);
    }
    else{
      return this.http.get(`${this.apiUrl}popular-destination/?lang=${langCode}`);
    }
  }

  getPopularDestinationById(id: number,langCode: string): Observable<any> {
    if(langCode === ""){
      return this.http.get(`${this.apiUrl}popular-destination/${id}`);
    }
    else {
      return this.http.get(`${this.apiUrl}popular-destination/${id}?lang=${langCode}`);
    }
  }

  create(request: any): Observable<any> {
    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));
    formData.append('IsPublish', request.isPublish.toString());

    return this.http.post(`${this.apiUrl}popular-destination`, formData);
  }

  update(id: number,request: any): Observable<any> {

    const formData = new FormData();

    if (request.image) {
      formData.append('Image', request.image);
    }

    formData.append('Data', JSON.stringify(request.data));
    formData.append('IsPublish', request.isPublish.toString());

    return this.http.put(`${this.apiUrl}popular-destination/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}popular-destination/${id}`);
  }
}
